import nBossConnection from 'modules/base/service/nBossConnection';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import OpcDaWriterLogTableService from '../service/OpcDaWriterLogTableService';
// import ShowChartButton from '../component/ShowChartButton';

const config = {
	key: 'opcDaWriterLogTable',
	topic: 'opcDaWriterLog',
	service: OpcDaWriterLogTableService,
	editFormState: item => `/opc-da-writer-log/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['search', 'refresh', 'new'],
	rowAction: ['exportData', 'modify', 'delete'],
	rowButtonList: [/*{ key: 'showChart', component: ShowChartButton }*/],
	exportData: {
		tooltip: 'Export to XLSX',
		link: item => `${nBossConnection.basePath}opcDaWriterLogTableControl/exportToXlsx?id=${item.id}`
	},
	columns: [
		{
			key: 'name'
		},
		{
			key: 'tableName'
		},
		{
			key: 'description'
		}
	]
};

function OpcDaWriterLogTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('opcDaWriterLogTable', reducer('opcDaWriterLogTable'))(OpcDaWriterLogTable);
